import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Save, Radio } from 'lucide-react';
import { toast } from 'sonner';
import { useSettings } from '../../contexts/SettingsContext';
import { toYouTubeEmbed } from '../../lib/youtube';

const StreamingManager = () => {
  const { settings, updateSettings } = useSettings();
  const [form, setForm] = useState({
    streaming_makkah_url: settings.streaming_makkah_url || '',
    streaming_madinah_url: settings.streaming_madinah_url || '',
  });
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateSettings({
        streaming_makkah_url: toYouTubeEmbed(form.streaming_makkah_url),
        streaming_madinah_url: toYouTubeEmbed(form.streaming_madinah_url),
      });
      toast.success('Link streaming berhasil disimpan!');
    } catch (e) {
      toast.error('Gagal menyimpan link streaming');
    } finally {
      setSaving(false);
    }
  };

  const inputCls = 'w-full px-4 py-3 rounded-xl border border-stone-200 focus:border-emerald-500 focus:ring-2 focus:ring-emerald-200 outline-none font-body';

  return (
    <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="space-y-6">
      <div className="bg-white rounded-2xl border border-stone-200 p-6">
        <div className="flex items-center gap-3 mb-6">
          <div className="w-11 h-11 rounded-full bg-emerald-50 flex items-center justify-center">
            <Radio className="w-6 h-6 text-emerald-700" />
          </div>
          <div>
            <h3 className="text-lg font-heading font-bold text-primary-dark">Link Live Streaming</h3>
            <p className="text-sm font-body text-text-secondary">Ganti link YouTube Live sewaktu-waktu</p>
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <label className="block text-sm font-body font-medium text-text-primary mb-2">Live Makkah (Masjidil Haram)</label>
            <input
              type="text"
              data-testid="streaming-makkah-input"
              value={form.streaming_makkah_url}
              onChange={(e) => setForm({ ...form, streaming_makkah_url: e.target.value })}
              className={inputCls}
              placeholder="https://www.youtube.com/watch?v=..."
            />
          </div>
          <div>
            <label className="block text-sm font-body font-medium text-text-primary mb-2">Live Madinah (Masjid Nabawi)</label>
            <input
              type="text"
              data-testid="streaming-madinah-input"
              value={form.streaming_madinah_url}
              onChange={(e) => setForm({ ...form, streaming_madinah_url: e.target.value })}
              className={inputCls}
              placeholder="https://www.youtube.com/watch?v=..."
            />
          </div>
          <p className="text-xs font-body text-text-secondary">
            Tempel link YouTube apa saja (watch, youtu.be, atau live). Sistem otomatis mengubahnya ke format embed.
          </p>
        </div>

        <button
          data-testid="streaming-save-btn"
          onClick={handleSave}
          disabled={saving}
          className="mt-6 flex items-center gap-2 px-6 py-3 bg-emerald-700 hover:bg-emerald-800 text-white rounded-full font-body font-medium transition-colors disabled:opacity-50"
        >
          <Save className="w-5 h-5" />
          {saving ? 'Menyimpan...' : 'Simpan Link'}
        </button>
      </div>
    </motion.div>
  );
};

export default StreamingManager;
